import React, { useState, useEffect } from "react";
import { authenticateApp } from "../../utils/auth";
import { getAuthenticatedApps, authApp, unauthApp } from "../../services/api"; // Updated to include `authApp`
import { FaCheck } from "react-icons/fa6";
import { MdOutlineAdd } from "react-icons/md";
import { DataState } from "../../context/DataProvider";
import Loader from "../../components/custom/Loader";
import { dataSources, integrationData } from "../../utils/constants";
import { Link, useNavigate } from "react-router-dom";
let apps_data = [...integrationData, ...dataSources];
apps_data = apps_data.map((app, unique_index) => {
  app.unique_index = unique_index;
  return app;
});

const SetupPage = ({ bot_id }) => {
  const [isNewUser, setIsNewUser] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfNewUser = async () => {
      try {
        const response = await fetch("/api/check-user");
        const data = await response.json();
        if (data.isNewUser) {
          setIsNewUser(true);
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Error checking user status:", error);
        navigate("/not-found");
      }
    };
    checkIfNewUser();
  }, [navigate]);

  const { userGoogleId: user_google_id } = DataState();

  const [loading, setLoading] = useState(false);
  const [integratedApps, setIntegratedApps] = useState([]);
  const [notIntegratedApps, setNotIntegratedApps] = useState([]);

  const fetchIntegratedApps = async () => {
    setLoading(true);
    try {
      const result = await getAuthenticatedApps(user_google_id, bot_id);
      console.log("authenticated apps:", result);
      const integrated = result.apps;
      let unique_index = 0;
      // Filter triggerOptions to separate integrated and non-integrated apps
      const integratedApps = apps_data.filter(
        (app) => integrated.includes(app.value)
        // (integrated.includes(app.value) || app.value === "jira")
      );
      const notIntegratedApps = apps_data.filter(
        (app) => !integrated.includes(app.value)
        // (app) => (!integrated.includes(app.value) && app.value !== "jira")
      );

      setIntegratedApps(integratedApps);
      setNotIntegratedApps(notIntegratedApps);
    } catch (error) {
      console.error("Failed to fetch integrated apps:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIntegratedApps();
  }, [user_google_id, bot_id]);

  const handleIntegrateButtonClick = async (selectedAppForIntegration) => {
    if (selectedAppForIntegration) {
      setLoading(true);
      await authenticateApp(
        selectedAppForIntegration.value,
        // bot_id,
        user_google_id,
        fetchIntegratedApps
      );
    }
  };

  const handleUnAuthorisationButtonClick = async (selectedAppForUnauth) => {
    if (selectedAppForUnauth) {
      setLoading(true);
      const response = await unauthApp(
        selectedAppForUnauth.value,
        bot_id,
        user_google_id
      );
      if (response.error) {
        console.error("Error:", response.error);
      }
      fetchIntegratedApps();
    }
  };
  
  if (!isNewUser) {
    return <div className="bg-zinc-900 text-white">Loading...</div>;
  }
  return (
    <div className="h-screen w-screen bg-zinc-800">
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-black opacity-50 absolute inset-0"></div>
        <div className="bg-3 h-[90%] max-w-3xl w-[90%] rounded-lg flex flex-col z-10">
          <div className="flex justify-between gap-3 br-1 border-b px-3 py-5">
            <h1 className="px-3 py-1.5 text-xl font-bold">Add Integrations</h1>
          </div>

          <div className="flex-grow overflow-y-auto p-4">
            {loading ? (
              <div className="flex items-center justify-center text-p-text min-h-96">
                <span className="h-12">
                  <Loader />
                </span>
              </div>
            ) : (
              <>
                <div className="flex flex-wrap gap-x-8 gap-y-4 mb-4">
                  {integratedApps.map((item) => (
                    <div
                      key={item.unique_index}
                      className="flex border border-zinc-400 rounded-full items-center gap-2 p-1"
                    >
                      <div className="bg-zinc-200 rounded-lg ml-2 p-1">
                        <img
                          alt={item.label}
                          src={item.image}
                          className="h-7 w-7"
                        />
                      </div>
                      <div className="ml-1 text-p-text text-lg font-semibold text-center">
                        {item.label}
                      </div>
                      <button
                        onClick={() => handleUnAuthorisationButtonClick(item)}
                        className="bg-green-700 hover:bg-green-800 transition-all duration-300 p-3 rounded-full ml-3 text-s ml-6m"
                      >
                        <FaCheck />
                      </button>
                    </div>
                  ))}
                  {notIntegratedApps.map((item, index) => (
                    <div
                      key={`Not-integrated-app-${item.unique_index}`}
                      className="flex border border-zinc-400 rounded-full items-center gap-2 p-1"
                    >
                      <div className="bg-zinc-200 rounded-lg ml-2 p-1">
                        <img
                          alt={item.label}
                          src={item.image}
                          className="h-7 w-7"
                        />
                      </div>
                      <div className="ml-1 text-p-text text-lg font-semibold text-center">
                        {item.label}
                      </div>
                      <button
                        onClick={() => handleIntegrateButtonClick(item)}
                        className="bg-zinc-100 hover:bg-zinc-300 transition-all duration-300 p-3 rounded-full text-sm text-zinc-700 font-bold ml-6"
                      >
                        <MdOutlineAdd />
                      </button>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          <div className="p-5 flex justify-end items-center">
            <Link
              to="/chat"
              className="flex items-center justify-center w-fit font-semibold leading-[24px] px-4 first:sm:text-lg capitalize bg-zinc-200 text-zinc-800 rounded-xl h-10"
            >
              Continue
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupPage;
